import { render, staticRenderFns } from "./mo-tab.html?vue&type=template&id=6ace8d72&external"
import script from "./mo-tab.ts?vue&type=script&lang=ts&external"
export * from "./mo-tab.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports